const guiColors = {
    'motion-primary': '#13261f',
    'motion-primary-transparent': '#13261fe6',
    'motion-tertiary': '#080f0f',

    'looks-secondary': '#13261f',
    'looks-transparent': '#ff4d4d59',
    'looks-light-transparent': '#ff4d4d26',
    'looks-secondary-dark': 'hsla(163, 35%, 21%, 1)',
	
	'looks-secondary-light': '#374A43', //light
    'looks-secondary-lighter': '#5D7069', //lighter
    'looks-secondary-darker': 'hsla(163, 35%, 15%, 1)', //darker
    'looks-secondary-deep-dark': 'hsla(163, 35%, 07%, 1)', //darkest

    'extensions-primary': 'hsla(10, 85%, 65%, 1)',
    'extensions-tertiary': 'hsla(10, 85%, 40%, 1)',
    'extensions-transparent': 'hsla(10, 85%, 65%, 0.35)',
    'extensions-light': 'hsla(10, 57%, 85%, 1)',

    'drop-highlight': '#258C8C'
};

const blockColors = {
    checkboxActiveBackground: '#13261f',
    checkboxActiveBorder: '#080f0f'
};

export {
    guiColors,
    blockColors
};
